import React from 'react';

class Switch6Icon extends React.Component {
  render() {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_241_1285)">
          <path
            d="M68.086 8.02393H11.914C8.64779 8.02393 6 10.6717 6 13.9379V66.0619C6 69.3281 8.64779 71.9759 11.914 71.9759H68.086C71.3522 71.9759 74 69.3281 74 66.0619V13.9379C74 10.6717 71.3522 8.02393 68.086 8.02393Z"
            fill="#F7F4F1"
          />
          <path
            d="M61.066 16.1199H18.934C16.4852 16.1199 14.5 18.105 14.5 20.5539V59.4479C14.5 61.8967 16.4852 63.8819 18.934 63.8819H61.066C63.5148 63.8819 65.5 61.8967 65.5 59.4479V20.5539C65.5 18.105 63.5148 16.1199 61.066 16.1199Z"
            fill="white"
          />
          <path
            d="M68.0862 7.22392H11.9142C8.2122 7.22392 5.2002 10.2359 5.2002 13.9379V66.0639C5.2002 69.7659 8.2122 72.7779 11.9142 72.7779H68.0862C71.7882 72.7779 74.8002 69.7659 74.8002 66.0639V13.9359C74.8002 10.2339 71.7882 7.22192 68.0862 7.22192V7.22392ZM73.2002 66.0639C73.2002 68.8839 70.9062 71.1779 68.0862 71.1779H11.9142C9.0942 71.1779 6.8002 68.8839 6.8002 66.0639V13.9359C6.8002 11.1159 9.0942 8.82192 11.9142 8.82192H68.0862C70.9062 8.82192 73.2002 11.1159 73.2002 13.9359V66.0639Z"
            fill="#83827F"
          />
          <path
            d="M61.0662 15.3198H18.9342C16.0482 15.3198 13.7002 17.6678 13.7002 20.5538V59.4458C13.7002 62.3318 16.0482 64.6798 18.9342 64.6798H61.0642C63.9502 64.6798 66.2982 62.3318 66.2982 59.4458V20.5538C66.2982 17.6678 63.9502 15.3198 61.0642 15.3198H61.0662ZM64.7002 59.4458C64.7002 61.4498 63.0702 63.0798 61.0662 63.0798H18.9342C16.9302 63.0798 15.3002 61.4498 15.3002 59.4458V20.5538C15.3002 18.5498 16.9302 16.9198 18.9342 16.9198H61.0642C63.0682 16.9198 64.6982 18.5498 64.6982 20.5538V59.4458H64.7002Z"
            fill="#83827F"
          />
          <path
            d="M58.3603 54.0439C57.9023 54.0439 57.5303 54.4159 57.5303 54.8739C57.5303 55.3319 57.9023 55.7039 58.3603 55.7039C58.8183 55.7039 59.1903 55.3319 59.1903 54.8739C59.1903 54.4159 58.8183 54.0439 58.3603 54.0439Z"
            fill="#83827F"
          />
          <path
            d="M30.8726 32.24C28.2646 32.24 26.1426 30.118 26.1426 27.51C26.1426 24.902 28.2646 22.78 30.8726 22.78C33.4806 22.78 35.6026 24.902 35.6026 27.51C35.6026 30.118 33.4806 32.24 30.8726 32.24ZM30.8726 24.356C29.1326 24.356 27.7186 25.772 27.7186 27.51C27.7186 29.248 29.1326 30.664 30.8726 30.664C32.6126 30.664 34.0266 29.248 34.0266 27.51C34.0266 25.772 32.6126 24.356 30.8726 24.356Z"
            fill="url(#paint0_linear_241_1285)"
          />
          <path
            d="M49.1284 32.24C46.5204 32.24 44.3984 30.118 44.3984 27.51C44.3984 24.902 46.5204 22.78 49.1284 22.78C51.7364 22.78 53.8585 24.902 53.8585 27.51C53.8585 30.118 51.7364 32.24 49.1284 32.24V32.24ZM49.1284 24.356C47.3884 24.356 45.9744 25.772 45.9744 27.51C45.9744 29.248 47.3884 30.664 49.1284 30.664C50.8684 30.664 52.2824 29.248 52.2824 27.51C52.2824 25.772 50.8684 24.356 49.1284 24.356V24.356Z"
            fill="url(#paint1_linear_241_1285)"
          />
          <path
            d="M30.8726 44.73C28.2646 44.73 26.1426 42.608 26.1426 40C26.1426 37.392 28.2646 35.27 30.8726 35.27C33.4806 35.27 35.6026 37.392 35.6026 40C35.6026 42.608 33.4806 44.73 30.8726 44.73ZM30.8726 36.846C29.1326 36.846 27.7186 38.262 27.7186 40C27.7186 41.738 29.1326 43.154 30.8726 43.154C32.6126 43.154 34.0266 41.738 34.0266 40C34.0266 38.262 32.6126 36.846 30.8726 36.846Z"
            fill="url(#paint2_linear_241_1285)"
          />
          <path
            d="M49.1284 44.73C46.5204 44.73 44.3984 42.608 44.3984 40C44.3984 37.392 46.5204 35.27 49.1284 35.27C51.7364 35.27 53.8585 37.392 53.8585 40C53.8585 42.608 51.7364 44.73 49.1284 44.73V44.73ZM49.1284 36.846C47.3884 36.846 45.9744 38.262 45.9744 40C45.9744 41.738 47.3884 43.154 49.1284 43.154C50.8684 43.154 52.2824 41.738 52.2824 40C52.2824 38.262 50.8684 36.846 49.1284 36.846V36.846Z"
            fill="url(#paint3_linear_241_1285)"
          />
          <path
            d="M30.8726 57.222C28.2646 57.222 26.1426 55.1 26.1426 52.492C26.1426 49.884 28.2646 47.762 30.8726 47.762C33.4806 47.762 35.6026 49.884 35.6026 52.492C35.6026 55.1 33.4806 57.222 30.8726 57.222ZM30.8726 49.338C29.1326 49.338 27.7186 50.754 27.7186 52.492C27.7186 54.23 29.1326 55.646 30.8726 55.646C32.6126 55.646 34.0266 54.23 34.0266 52.492C34.0266 50.754 32.6126 49.338 30.8726 49.338V49.338Z"
            fill="url(#paint4_linear_241_1285)"
          />
          <path
            d="M49.1284 57.222C46.5204 57.222 44.3984 55.1 44.3984 52.492C44.3984 49.884 46.5204 47.762 49.1284 47.762C51.7364 47.762 53.8585 49.884 53.8585 52.492C53.8585 55.1 51.7364 57.222 49.1284 57.222V57.222ZM49.1284 49.338C47.3884 49.338 45.9744 50.754 45.9744 52.492C45.9744 54.23 47.3884 55.646 49.1284 55.646C50.8684 55.646 52.2824 54.23 52.2824 52.492C52.2824 50.754 50.8684 49.338 49.1284 49.338V49.338Z"
            fill="url(#paint5_linear_241_1285)"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_241_1285"
            x="3.8002"
            y="5.82192"
            width="75.5996"
            height="71.5559"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1.6" dy="1.6" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_241_1285"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_241_1285"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_241_1285"
            x1="27.4731"
            y1="23.6262"
            x2="33.8946"
            y2="30.992"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_241_1285"
            x1="45.729"
            y1="23.6262"
            x2="52.1505"
            y2="30.992"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_241_1285"
            x1="27.4731"
            y1="36.1161"
            x2="33.8946"
            y2="43.482"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_241_1285"
            x1="45.729"
            y1="36.1161"
            x2="52.1505"
            y2="43.482"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_241_1285"
            x1="27.4731"
            y1="48.6081"
            x2="33.8946"
            y2="55.9739"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_241_1285"
            x1="45.729"
            y1="48.6081"
            x2="52.1505"
            y2="55.9739"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
}

export default Switch6Icon;
